import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';

import s from '../styles/DetailContent.module.css';

const Knowledge15 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='ゴルフ会員権取得後の代表的な退会方法２つ' fontWeight={700} />
                <p>
                    ゴルフ会員権を退会する方法として一般的なのは以下の２つです。
                    <br />
                    ・会員権取引業者に売却を依頼して第三者に会員権を売り渡す
                    <br />
                    ・直接ゴルフ場に退会届を提出する。
                    <br />
                    それぞれの方法についてポイントやメリット・デメリットをご紹介します。
                </p>

                <Heading3 title='会員権取引業者に売却を依頼して第三者に会員権を売り渡す' />
                <p>
                    １つ目は会員権を第三者に売却する方法です。
                    <br />
                    会員権を売却するには、個人で売却先の相手を探すことも可能ではありますが、購入希望者を個人で見つけるのは非常に難易度が高く、複雑であるためゴルフ会員権取引業者に依頼することをおすすめします。
                    <br />
                    ゴルフ会員権取引業者を選ぶ際は、関東ゴルフ会員権取引業協同組合や関西ゴルフ会員権取引業協同組合、中部ゴルフ会員権取引協同組合に加盟している業者がおすすめです。（※当社はすべてに加盟しています。）
                    <br />
                    これらの組合に加入するには所定の審査をクリアする必要があるため、評判が悪い取引業者やトラブルを起こした業者などは加入出来ないようになっています。
                    <br />
                    組合に加入している業者の中でも、実績のある業者を選ぶことも忘れてはいけません。
                    <br />
                    実績のある業者の方がゴルフ会員権の相場への理解も深く、売買に関する知識や経験も豊富なため、適切な条件を提案してくれます。
                    <br />
                    詳しくは<a href='/knowledge/19'>ゴルフ会員権の売却について</a>を参考にしてください。
                </p>

                <Heading3 title='直接ゴルフ場に退会届を提出する' />
                <p>
                    ゴルフ会員権を退会するもう一つの方法としては、直接ゴルフ場に退会届を提出する方法が挙げられます。
                    <br />
                    しかし、この方法にはいくつかのデメリットがあります。
                    <br />
                    預託金をゴルフ場に預けている場合は、ゴルフ場の経営状態によって預託金が返還されるのかが決定されるため、一部のゴルフ場は余裕がなく、その場合、実際に返還されるケースはあまり多くありません。
                    <br />
                    預託金をとっていないゴルフ場の会員権を売却する際は、返還される預託金が無いので第三者譲渡売却をおすすめしています。
                    <br />
                    年会費がもったいないので退会したいというお客様もいらっしゃいますが、退会のためにも書類を準備しなければならないため、ゴルフ会員権取引業者への売却を選んだ方が手間が少なかったということもあります。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='【ゴルフ会員権】預託金がある場合の退会方法' fontWeight={700} />
                <p>
                    実際にゴルフ場の会員が退会する際の具体的な方法をみていきましょう。
                    <br />
                    ここでは預託金があるケースでご紹介します。
                </p>

                <Heading3 title='退会・預託金返還を申し出る' />
                <p>
                    まずは退会する旨、併せて預託金の返還を申し出ましょう。
                    <br />
                    この際に注意したいのが、退会出来る期間に期限が設けられている場合があるということです。
                    <br />
                    まずは退会の申し出が契約上、可能であるのかを事前に確認しておきましょう。
                    <br />
                    退会・預託金返還の請求を申し出た際のゴルフ場の対応によって今後取るべき流れは変わってきます。
                    <br />
                    退会と預託金の返還をゴルフ場が承諾した場合は、指示された手続きをとって退会手続完了となりますが、先述の通り、一般的に預託金が全額返還されるケースは多くはないとされているため、その際にどうすればよいかも検討しておく必要があります。
                </p>

                <Heading3 title='交渉で一部のみでも預託金の返還を請求する' />
                <p>
                    預託金の全額返還が難しいとなった場合には、現実的にどのくらいまでであれば預託金が返還出来るのかを交渉します。
                    <br />
                    預託金は預けたお金であるため訴訟を起こすことも出来ますが、勝訴となった場合でも預託金が返還されることは少ないため、あまりおすすめは出来ません。
                    <br />
                    毎年一定の金額を複数年に分けて預託金を返還する分割返還をゴルフ場から提案されることもありますので、ご自身で何が最適なのかをご判断の上、交渉するとよいでしょう。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='退会するならゴルフ会員権「売却」がおすすめです' fontWeight={700} />
                <p>
                    価格が高騰している時代に購入したゴルフ会員権は現在売買価格が下落しているため、煩わしい手続をするくらいならと直接退会を選ぶ方も少なくありません。
                    <br />
                    しかし、直接退会しても一般的には預託金が全額返還されることは少ないとされているため、ゴルフ会員権を手放す際には売却をおすすめします。
                    <br />
                    ご売却の際にはゴルフ会員権の売買実績を有する住地ゴルフにまずはご相談ください。
                    <br />
                    そもそもゴルフ会員権とは何かという基礎知識は<a href='/knowledge/8'>こちら</a>をご覧ください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge15;
